export default function Footer() {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const links = [
    { label: 'How It Works', href: '#how-it-works' },
    { label: 'Features', href: '#features' },
    { label: 'Who It\'s For', href: '#audience' },
    { label: 'Pricing', href: '#pricing' },
    { label: 'Request a Demo', href: '#demo-form' },
  ];

  return (
    <footer data-testid="footer-section" className="bg-vf-forest py-16 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start gap-10 mb-12">
          {/* Logo */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="font-heading text-2xl font-bold text-white tracking-tight">
                VitalsFlow
              </span>
              <span className="inline-block w-2 h-2 rounded-full bg-vf-mint pulse-dot" />
              <span className="text-white/60 font-body text-sm font-medium ml-[-4px]">AI</span>
            </div>
            <p className="font-body text-sm text-white/40 max-w-xs leading-relaxed">
              AI-powered clinical documentation and billing automation built specifically for rural American healthcare.
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-wrap gap-x-8 gap-y-3">
            {links.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollTo(link.href)}
                className="font-body text-sm text-white/50 hover:text-vf-mint transition-colors duration-200"
              >
                {link.label}
              </button>
            ))}
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-8">
          <p className="font-body text-xs text-white/30 leading-relaxed max-w-2xl">
            VitalsFlow AI is HIPAA-compliant, Section 330-aligned, and built specifically for rural
            American healthcare. &copy; {new Date().getFullYear()} VitalsFlow AI. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
